// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iCgd","toggleWrap":"styles_toggleWrap__iJaVe","content":"styles_content__kdDz9","selectAreaCode":"styles_selectAreaCode__1iouf"};